import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navigated-searchbar',
  templateUrl: './navigated-searchbar.component.html',
  styleUrls: ['./navigated-searchbar.component.scss'],
})
export class NavigatedSearchbarComponent implements OnInit {
  @Input() placeholder = 'Cari';
  @Input() isLoading: boolean;
  @Input() navigateTo = '/search-products';
  @Input() queryParams: { [key: string]: string } | undefined;

  constructor(private router: Router) {}

  ngOnInit() {}

  navigateToSearchProduct() {
    if (!!this.queryParams) {
      this.router.navigate([this.navigateTo], { queryParams: { ...this.queryParams } });
      return;
    }

    this.router.navigate([this.navigateTo]);
  }
}
